import { useEffect } from 'react';
import * as Linking from 'expo-linking';
import { router } from 'expo-router';
import usePlatform from './usePlatform';

// The shared (home,search,notifications,settings) layout mounts once per tab
// group (up to 4 instances). Without these guards, every deep link fires 4×
// (4 listeners + 4 getInitialURL calls), pushing duplicate screens onto the
// stack and corrupting navigation when the user presses back through them.
let activeListenerCount = 0;
let sharedSubscription = null;
let initialURLHandled = false;

function useDeepLinkHandler() {
    const { isWeb } = usePlatform();

    useEffect(() => {
        if (isWeb) return;

        // Only the first mounted instance registers the listener + initial URL.
        if (activeListenerCount === 0) {
            const handleDeepLink = (event) => {
                const { path } = Linking.parse(event.url);
                if (path) {
                    router.push(`/${path}`);
                }
            };

            sharedSubscription = Linking.addEventListener('url', handleDeepLink);

            if (!initialURLHandled) {
                initialURLHandled = true;
                Linking.getInitialURL().then((url) => {
                    if (url) {
                        const { path } = Linking.parse(url);
                        if (path) {
                            // Cold-start deep link: anchor beneath so modals present correctly
                            // and the tab stack isn't left without an initial screen.
                            router.push(`/${path}`, { withAnchor: true });
                        }
                    }
                });
            }
        }
        activeListenerCount++;

        return () => {
            activeListenerCount--;
            if (activeListenerCount === 0 && sharedSubscription) {
                sharedSubscription.remove();
                sharedSubscription = null;
            }
        };
    }, [isWeb]);
}

export default useDeepLinkHandler;
